import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import BackLink from '../ui/BackLink';
import { helpCMSAPI, HELP_BUCKETS } from './helpCMS';

/**
 * HelpBucketPage — Lists all articles in a workflow bucket.
 */
export default function HelpBucketPage() {
  const { bucketId } = useParams();
  const navigate = useNavigate();
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  const bucket = HELP_BUCKETS.find(b => b.id === bucketId);

  useEffect(() => {
    async function load() {
      const results = await helpCMSAPI.getArticles(bucketId);
      setArticles(results);
      setLoading(false);
    }
    load();
  }, [bucketId]);

  return (
    <div className="p-6 max-w-3xl mx-auto">
      {/* Back link */}
      <BackLink to="/help" label="Back to Help Center" className="mb-4" />

      <h1 className="text-lg font-semibold mb-1" style={{ font: 'var(--text-h2)', color: 'var(--color-text-primary)' }}>
        {bucket ? bucket.label : 'Articles'}
      </h1>
      {bucket && (
        <p className="text-sm mb-6" style={{ color: 'var(--color-text-secondary)' }}>
          {bucket.description}
        </p>
      )}

      {loading ? (
        <div className="space-y-3">
          {[1, 2, 3].map(i => (
            <div key={i} className="animate-pulse h-16 bg-gray-100" style={{ borderRadius: 'var(--radius-md)' }} />
          ))}
        </div>
      ) : articles.length === 0 ? (
        <p className="text-sm" style={{ color: 'var(--color-text-muted)' }}>No articles in this section yet.</p>
      ) : (
        <div className="space-y-2">
          {articles.map((article) => (
            <button
              key={article.id}
              type="button"
              className="w-full text-left p-4 border transition-colors hover:border-red-200"
              style={{ borderColor: 'var(--color-border)', borderRadius: 'var(--radius-md)', backgroundColor: 'var(--color-surface)' }}
              onClick={() => navigate(`/help/article/${article.id}`)}
            >
              <p className="text-sm font-medium" style={{ color: 'var(--color-text-primary)' }}>
                {article.title}
              </p>
              {article.anchors && article.anchors.length > 0 && (
                <p className="text-xs mt-1" style={{ color: 'var(--color-text-muted)' }}>
                  {article.anchors.map(a => a.label).join(' · ')}
                </p>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
